import React from "react";
import { MdOutlineClose } from "react-icons/md";
import Lottie from "react-lottie";
import happy from "../../Images/happy.json";
import sad from "../../Images/sad.json";
import angry from "../../Images/angry.json";
import disappoint from "../../Images/disappointed.json";

const MoodModal = ({
  modal,
  toggle,
  handleMoodSelection,
}) => {
 
  const happyDefaultOptions = {
    loop: true,
    autoplay: true,
    animationData: happy,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const sadDefaultOptions = {
    loop: true,
    autoplay: true,
    animationData: sad,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const angryDefaultOptions = {
    loop: true,
    autoplay: true,
    animationData: angry,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const disappointDefaultOptions = {
    loop: true,
    autoplay: true,
    animationData: disappoint,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <div
      className={` ${
        modal ? "fixed" : "hidden"
      } fixed top-0 left-0 w-[100%] h-[100%] z-40 flex  justify-center`}
    >
      {/* OverLay  */}
      <div className="absolute w-[100%] h-[100%] bg-black opacity-75"></div>

      {/* Conetnt  */}
      <div className=" bg-white rounded-lg w-[90%] md:w-[60%]  p-2 absolute z-10  mt-10">
        {/* Model Header  */}
        <div className="modelHeadingBackground p-3 border-blue-800 rounded flex items-center justify-between">
          <h1 className="text-black text-5xl font-semibold">Select a mood</h1>
          <span className=" text-black text-xl cursor-pointer" onClick={toggle}>
            <MdOutlineClose size={24} />
          </span>
        </div>

        {/* Modal Body  */}
        <div className="px-2 py-1  my-2 h-[100%] border-purple-800 rounded flex ">
          <div
            className="flex justify-center items-center flex-col gap-4 lottie-container"
            onClick={() => handleMoodSelection("happy")}
          >
            <Lottie options={happyDefaultOptions} />
            <p className="sm:text-5xl text-3xl text-center">Happy</p>
          </div>
          <div
            className="flex justify-center items-center flex-col lottie-container"
            onClick={() => handleMoodSelection("sad")}
          >
            <Lottie options={sadDefaultOptions} />
            <p className="sm:text-5xl text-3xl text-center">Sad</p>
          </div>
          <div
            className="flex justify-center items-center flex-col lottie-container"
            onClick={() => handleMoodSelection("angry")}
          >
            <Lottie options={angryDefaultOptions} />
            <p className="sm:text-5xl text-3xl text-center">Angry</p>
          </div>
          <div
            className="flex justify-center items-center flex-col lottie-container"
            onClick={() => handleMoodSelection("disappointed")}
          >
            <Lottie options={disappointDefaultOptions} />
            <p className="sm:text-5xl text-3xl text-center">Disappointed</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MoodModal;
